<template>
  <div class="dialog-export-to-file" data-cy="dialog-export-to-file">
    <el-card shadow="never">
      <template v-if="!media.sm">
        <div class="row">
          <div class="col-7">
            <h5>Lista de campos exportables</h5>
            <el-checkbox-group v-model="checkList" @change="onCheckboxChange">
              <div class="row" v-for="item in fields">
                <div class="col label-check">
                  <el-checkbox class="field-selected"
                               :label="item.name"
                               :key="item.key"
                               :checked="true"
                               :disabled="item.disabled"
                               data-cy="field-selected"></el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </div>
          <div class="col-5 pt-5">
            <div class="row">
              <div class="col label-check">
                <el-checkbox class="select-all"
                             :indeterminate="isIndeterminate"
                             v-model="checkAll"
                             @change="handleCheckAllChange"
                             data-cy="select-all">Selecionar Todos</el-checkbox>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <el-button type="primary"
                           class="exportExcel"
                           size="medium"
                           :disabled="checkList.length === 2"
                           @click="exportExcel"
                           data-cy="exportExcel">
                  <font-awesome-icon icon="file-excel"></font-awesome-icon>
                  Exportar a Excel
                </el-button>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <el-button type="primary"
                           class="exportPdf"
                           size="medium"
                           :disabled="checkList.length === 2"
                           @click="exportPdf"
                           data-cy="exportPdf">
                  <font-awesome-icon icon="file-pdf"></font-awesome-icon>
                  Exportar a Pdf
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="media.sm">
        <div class="row">
          <div class="col-8">
            <h5>Lista de campos exportables</h5>
            <el-checkbox-group v-model="checkList" @change="onCheckboxChange">
              <div class="row" v-for="item in fields">
                <div class="col label-check">
                  <el-checkbox class="field-selected"
                               :label="item.name"
                               :key="item.key"
                               :checked="true"
                               :disabled="item.disabled"
                               data-cy="field-selected"></el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="row mt-3 justify-content-center">
          <div class="col-8 label-check">
            <h5>Acciones</h5>
            <el-checkbox class="select-all"
                         :indeterminate="isIndeterminate"
                         v-model="checkAll"
                         @change="handleCheckAllChange"
                         data-cy="select-all">Selecionar Todos</el-checkbox>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-8 mt-2">
            <el-button type="primary"
                       class="exportExcel"
                       size="medium"
                       :disabled="checkList.length === 2"
                       @click="exportExcel"
                       data-cy="exportExcel">
              <font-awesome-icon icon="file-excel"></font-awesome-icon>
              Exportar a Excel</el-button>
          </div>
        </div>
        <div class="row justify-content-center mt-2">
          <div class="col-8">
            <el-button type="primary"
                       class="exportPdf"
                       size="medium"
                       :disabled="checkList.length === 2"
                       @click="exportPdf"
                       data-cy="exportPdf">
              <font-awesome-icon icon="file-pdf"></font-awesome-icon>
              Exportar a Pdf
            </el-button>
          </div>
        </div>
        <div class="row justify-content-center mt-2">
          <div class="col-8">
            <el-button type="danger"
                       class="closeDialog"
                       size="medium"
                       @click="closeDialog"
                       data-cy="closeDialog">
              <font-awesome-icon icon="chevron-left"></font-awesome-icon>
              Volver
            </el-button>
          </div>
        </div>
      </template>
    </el-card>
  </div>
</template>

<script>
import {Button, Checkbox, CheckboxGroup, Tooltip} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";

export default {
  name: "ExportToFile",
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Tooltip.name]: Tooltip,
  },
  props: {
    fields: Array,
  },
  data() {
    return {
      checkList: [],
      checkAll: true,
      isIndeterminate: true,
    };
  },
  mixins: [ScreenSizeMixin],
  methods: {
    exportExcel() {
      this.$log.debug('toolbar exportToExcel', this.checkList, this.fields)
      this.$emit('on-export-excel', this.checkList, this.fields)
    },
    exportPdf() {
      this.$log.debug('toolbar exportToPdf', this.checkList, this.fields)
      this.$emit('on-export-pdf', this.checkList, this.fields)
    },
    closeDialog() {
      this.$log.debug('toolbar closeDialog')
      this.$emit('on-close-export')
    },
    handleCheckAllChange(val) {
      this.checkList = val ? this.fields.map(x => x.name) : this.fields.filter(x => x.disabled).map(x => x.name);
      this.isIndeterminate = false;
    },
    onCheckboxChange() {
      this.checkAll = this.fields.length === this.checkList.length
    },
  }
}
</script>

<style scoped>
.label-check label {
  text-transform: capitalize;
}
</style>
